<template>
    <div>
        <div class="row">
            <div class="col">
                <label class="d-block">
                    <strong>First name</strong>
                    <input v-on:input="onChange" v-model="firstName" class="form-control" type="text"
                           :name="'travellers[' + travellerIndex + '][firstName]'">
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="d-block">
                    <strong>Last name</strong>
                    <input v-on:input="onChange" v-model="lastName" class="form-control" type="text"
                           :name="'travellers[' + travellerIndex + '][lastName]'">
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="d-block">
                    <strong>Nationality</strong>
                    <country-code-selector v-on:country-selected="onNationalitySelected"
                                           :form-field-name="'travellers[' + travellerIndex + '][nationality]'"
                                           :prefilledCountryCode="nationality"></country-code-selector>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import CountryCodeSelector from "./CountryCodeSelector";

export default {
    components: {CountryCodeSelector},
    name: "OrderTravellerForm",
    props: {
        travellerIndex: {
            default: null,
            required: false
        },
        prefilledFirstName: {
            default: ''
        },
        prefilledLastName: {
            default: ''
        },
        prefilledNationality: {
            default: ''
        },
    },

    data: function () {
        return {
            firstName: this.prefilledFirstName,
            lastName: this.prefilledLastName,
            nationality: this.prefilledNationality
        }
    },

    methods: {
        onNationalitySelected(value) {
            this.nationality = value;
            this.onChange();
        },

        onChange() {
            this.$emit('traveller-updated', {
                travellerIndex: this.travellerIndex,
                firstName: this.firstName,
                lastName: this.lastName,
                nationality: this.nationality
            })
        }
    }
}
</script>

<style scoped>

</style>
